import React, { Component } from "react";
import { Icon } from "@iconify/react";
import robloxIcon from '@iconify/icons-simple-icons/roblox';
import unityIcon from '@iconify/icons-mdi/unity';
import unrealIcon from '@iconify/icons-mdi/unreal';
import openinnew from '@iconify/icons-mdi/open-in-new';

class About extends Component {
  render() {
    if (this.props.sharedBasicInfo) {
      var profilepic = "images/" + this.props.sharedBasicInfo.image;
      var resume = this.props.sharedBasicInfo.resume;
    }
    if (this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.about;
      var hello = this.props.resumeBasicInfo.description_header;
      var about = this.props.resumeBasicInfo.description;
    }

    return (
      <section id="about">
        <div className="col-md-12">
          <div className="row center mx-auto">
            <div className="col-md-4 mb-5 center">
              <div className="polaroid">
                <span style={{ cursor: "auto" }}>
                  <img
                    src={profilepic}
                    alt="Avatar placeholder"
                  />
                  <Icon
                    icon={unrealIcon}
                    style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                  <Icon
                    icon={unityIcon}
                    style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                  <Icon
                    icon={robloxIcon}
                    style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                  {resume ? (
                    <div style={{ marginTop: "18px" }}>
                      <a
                        href={resume}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="resume font-trebuchet"
                      >
                        Resume
                        <Icon
                          icon={openinnew}
                          style={{ marginLeft: "10px" }}
                        />
                      </a>
                    </div>
                  ) : null}
                </span>
              </div>
            </div>

            <div className="col-md-8 center">
              <div className="col-md-10">
                <div className="card">
                  <div
                    className="card-body font-trebuchet ml-3 mr-3"
                    style={{
                      height: "auto",
                      fontSize: "132%",
                      lineHeight: "200%",
                    }}
                  >
                    <span className="wave">{hello}</span>
                    <br />
                    {about}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
